<template>
  <footer class="footer mt-6">
    <div class="footer-inner">
      <div class="grid">
        <div class="col-12 md:col-4 footer-section">
          <h3 class="footer-logo-text">{{ shopName }}</h3>
          <p class="footer-text">
            <a href="mailto:ventas@kosexa.cl" class="footer-link">ventas@kosexa.cl</a>
          </p>
          <p class="footer-text footer-hours">{{ $t('footer.hours') }}</p>
        </div>

        <div class="col-12 md:col-4 footer-section">
          <h4>{{ $t('footer.explore') }}</h4>
          <ul>
            <li><router-link to="/">{{ $t('footer.home') }}</router-link></li>
            <li><router-link to="/catalogo-productos">{{ $t('footer.catalog') }}</router-link></li>
            <li><router-link to="/nosotros">{{ $t('footer.about') }}</router-link></li>
            <li><router-link to="/contacto">{{ $t('footer.contact') }}</router-link></li>
            <li><router-link to="/trabaja-con-nosotros">{{ $t('footer.jobs') }}</router-link></li>
          </ul>
        </div>

        <div class="col-12 md:col-4 footer-section">
          <h4>{{ $t('footer.follow') }}</h4>
          <div class="social-icons">
            <a href="#" class="social-link" :aria-label="$t('footer.facebookAria')"><i class="pi pi-facebook" aria-hidden="true" /></a>
            <a href="#" class="social-link" :aria-label="$t('footer.instagramAria')"><i class="pi pi-instagram" aria-hidden="true" /></a>
          </div>
        </div>
      </div>
      <div class="footer-powered">
        <p class="footer-powered__label">{{ $t('footer.poweredBy') }}</p>
        <a
          href="https://snat.cl"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-powered__brand"
          :aria-label="$t('footer.snatAria')"
        >
          <img
            src="@/assets/logo-snat.jpg"
            alt=""
            class="footer-powered__logo"
            width="36"
            height="36"
          />
          <span class="footer-powered__text">
            <span class="footer-powered__name">{{ $t('footer.snatName') }}</span>
            <span class="footer-powered__url">snat.cl</span>
          </span>
        </a>
      </div>
      <div class="footer-bottom">
        <p>{{ $t('footer.rights', { year, shop: shopName }) }}</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterTienda',
  computed: {
    shopName() {
      return (process.env.VUE_APP_SHOP_NAME || 'KOSEXA').trim();
    },
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.footer {
  background: var(
    --footer-gradient,
    linear-gradient(165deg, #0a100c 0%, #0f1612 42%, #070807 100%)
  );
  color: var(--text-color, #f4f2ee);
  padding: 3rem 1rem 2rem;
  border-top: 1px solid rgba(201, 169, 98, 0.28);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.03);
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.footer-section {
  padding: 1rem;
  text-align: center;
}

.footer-logo-text {
  font-size: 1.75rem;
  font-weight: 800;
  color: var(--primary-color, #c9a962);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 1rem;
}

.footer-text {
  font-size: 0.95rem;
  margin: 0.4rem 0;
  color: var(--text-secondary);
}

.footer-hours {
  font-size: 0.85rem;
  color: var(--text-muted-600);
}

.footer-link {
  color: #dcc885;
  text-decoration: none;
}

.footer-link:hover {
  text-decoration: underline;
}

h4 {
  font-size: 1rem;
  margin-bottom: 1rem;
  color: var(--primary-color, #c9a962);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

ul li {
  margin-bottom: 0.65rem;
}

ul li a {
  color: var(--text-color);
  text-decoration: none;
  font-size: 0.95rem;
  transition: color 0.2s ease;
}

ul li a:hover {
  color: var(--primary-over, #e4d4a4);
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 1.25rem;
}

.social-link {
  color: var(--text-color);
  font-size: 1.5rem;
  transition: color 0.2s ease, transform 0.2s ease;
}

.social-link:hover {
  color: var(--primary-color, #c9a962);
  transform: translateY(-2px);
}

.footer-powered {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.65rem;
  margin-top: 2rem;
  padding-top: 1.25rem;
  border-top: 1px solid var(--border-accent);
}

.footer-powered__label {
  margin: 0;
  font-size: 0.72rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted-600);
}

.footer-powered__brand {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  text-decoration: none;
  color: inherit;
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
  border: 1px solid rgba(201, 169, 98, 0.22);
  background: rgba(255, 255, 255, 0.03);
  transition: border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;
}

.footer-powered__brand:hover {
  border-color: rgba(201, 169, 98, 0.45);
  background: rgba(255, 255, 255, 0.06);
  transform: translateY(-1px);
}

.footer-powered__logo {
  width: 36px;
  height: 36px;
  object-fit: cover;
  border-radius: 10px;
  flex-shrink: 0;
}

.footer-powered__text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;
}

.footer-powered__name {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--text-color, #f4f2ee);
}

.footer-powered__url {
  font-size: 0.78rem;
  color: #dcc885;
}

.footer-bottom {
  text-align: center;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid var(--border-accent);
}

.footer-bottom p {
  font-size: 0.8rem;
  color: var(--text-muted-600);
  margin: 0;
}

@media (max-width: 768px) {
  .footer-logo-text {
    font-size: 1.4rem;
  }
}
</style>
